import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { InstantCardSearch } from '@sorare/core/src/components/search/InstantSearch';
import {
  AnalyticTag,
  Props as InstantCardSearchProps,
} from '@sorare/core/src/components/search/InstantSearch/types';
import SearchCardsContextProvider from '@sorare/core/src/contexts/searchCards/Provider';

import SearchLayout from './SearchLayout';
import { Props } from './types';

export interface FullProps extends Props {
  sport: Sport;
  includeCommonCards?: boolean;
  defaultFilters?: string[];
  getOptionalFilters?: InstantCardSearchProps['getOptionalFilters'];
  analyticsTags: AnalyticTag[];
  distinct?: InstantCardSearchProps['distinct'];
  defaultHitsPerPage?: number;
  editableLists?: boolean;
  alwaysShowFavoriteButton?: boolean;
}

const AdvancedCardSearch = ({
  children,
  sport,
  includeCommonCards,
  analyticsTags,
  defaultFilters,
  getOptionalFilters,
  defaultSort,
  initialIndexUIState,
  cardFilters,
  advancedCardFilters,
  defaultHitsPerPage,
  editableLists,
  distinct,
  ...rest
}: FullProps) => {
  const index = defaultSort || rest.sorts[0];

  return (
    <SearchCardsContextProvider
      includeCommonCards={Boolean(includeCommonCards)}
      cardFilters={cardFilters}
      advancedCardFilters={advancedCardFilters}
      editableLists={editableLists}
      galleryOwnerSlug={rest.galleryOwnerSlug}
    >
      <InstantCardSearch
        {...(index && { indexes: [index] })}
        availableSorts={rest.sorts}
        analyticsTags={analyticsTags}
        sport={sport}
        defaultFilters={defaultFilters}
        getOptionalFilters={getOptionalFilters}
        urlState
        initialIndexUIState={initialIndexUIState}
        {...(defaultHitsPerPage && { defaultHitsPerPage })}
        {...(distinct && { distinct })}
      >
        <SearchLayout
          cardFilters={cardFilters}
          advancedCardFilters={advancedCardFilters}
          editableLists={editableLists}
          sport={sport}
          {...rest}
        >
          {children}
        </SearchLayout>
      </InstantCardSearch>
    </SearchCardsContextProvider>
  );
};

export default AdvancedCardSearch;
